module.exports = __webpack_public_path__ + "static/media/blue-wheel.55f165e7.png";